import { render, staticRenderFns } from "./ServiceValueForm.vue?vue&type=template&id=3c1677b1&scoped=true"
import script from "./ServiceValueForm.vue?vue&type=script&lang=js"
export * from "./ServiceValueForm.vue?vue&type=script&lang=js"
import style0 from "./ServiceValueForm.vue?vue&type=style&index=0&id=3c1677b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1677b1",
  null
  
)

export default component.exports